import { type ReactNode, createContext } from 'react'

export interface VariantLineItem {
  id: number
  quantity: number
}

interface FrameBuilderCartContextProps {
  isCartProductAdding: boolean
  addItemsToCart: (variantLineItems: VariantLineItem[]) => Promise<boolean>
}

export const FrameBuilderCartContext =
  createContext<FrameBuilderCartContextProps>({
    isCartProductAdding: false,
    addItemsToCart: async () => false,
  })

interface FrameBuilderCartProviderProps {
  isCartProductAdding: boolean
  addItemsToCart: (variantLineItems: VariantLineItem[]) => Promise<boolean>
  children: ReactNode
}

export const FrameBuilderCartProvider = ({
  isCartProductAdding,
  addItemsToCart,
  children,
}: FrameBuilderCartProviderProps) => {
  return (
    <FrameBuilderCartContext.Provider
      value={{
        isCartProductAdding,
        addItemsToCart,
      }}
    >
      {children}
    </FrameBuilderCartContext.Provider>
  )
}
